<script>
/* eslint-disable */
import moment from "moment";
import { mapActions, mapState } from "vuex";
import sucursalesMixin from "@/mixins/sucursalesMixin";
export default {
  mixins: [sucursalesMixin],
  props: ["urlSiguiente"],
  data() {
    return {
      nombre: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      telefono: "",
      correo: "",
      codigoPostal: "",
      fechaNacimiento: "",
      sexo: "",
      terminos: false,
      noCorreo: false,
      botonDesactivado: false,
      tipoSucursal: "",
      sucursal: "",
      correoOpcional: false,
      listaTipoSucursales: ["Super Kompras", "Surtitienda", "Acropolis"],
      listaSucursales: [],
    };
  },
  computed: {
    ...mapState("configuracion", ["configuracionesCorreo"]),
  },
  created() {
    this.consultarConfiguracionesCorreo();
  },
  methods: {
    ...mapActions("configuracion", [
      "consultarConfiguracionCorreoDefecto",
    ]),
    async consultarConfiguracionesCorreo() {
      try {
        await this.consultarConfiguracionCorreoDefecto()
      } catch (error) {

      }
    },
    validarFormularioVerificacion() {
      this.botonDesactivado = true;
      const errores = [];
      const patronCorreo =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      const patronCodPostal = /^\d{5}$/;
      const patronFecha = /^\d{2}\/\d{2}\/\d{4}$/;

      if (this.nombre == "") {
        errores.push({ msg: "Proporcione un nombre" });
      }
      if (this.apellidoPaterno == "") {
        errores.push({ msg: "Proporcione un apellido paterno" });
      }
      if (this.apellidoMaterno == "") {
        errores.push({ msg: "Proporcione un apellido materno" });
      }
      if (this.telefono == "") {
        errores.push({ msg: "Proporcione un teléfono" });
      }

      if (this.correo == "") {
        errores.push({ msg: "Proporcione un correo" });
      }
      if (this.codigoPostal == "") {
        errores.push({ msg: "Proporcione un código postal" });
      }
      if (this.formatoFechaNacimiento == "") {
        errores.push({ msg: "Proporcione una fecha de nacimiento" });
      }
      if (this.sexo == "") {
        errores.push({ msg: "Proporcione un sexo" });
      }

      if (
        isNaN(this.telefono.toString()) ||
        this.telefono.toString().length != 10
      ) {
        errores.push({ msg: "Teléfono inválido" });
      }

      if (!patronCorreo.test(this.correo)) {
        errores.push({ msg: "Correo inválido" });
      }

      if (!patronCodPostal.test(this.codigoPostal.toString())) {
        errores.push({ msg: "Código postal inválido" });
      }

      if (!patronFecha.test(this.fechaNacimiento)) {
        errores.push({ msg: "Introduce una fecha valida" });
      }

      if (!this.revisarMayoriaEdad(this.formatoFechaNacimiento())) {
        errores.push({ msg: "Para continuar necesitas ser mayor de edad" });
      }

      if (this.terminos == false) {
        errores.push({
          msg: "Para continuar es necesario aceptar los términos y condiciones",
        });
      }

      if (this.sucursal == "") {
        errores.push({
          msg: "Selecciona una sucursal",
        });
      }


      if (errores.length > 0) {
        this.$swal({
          icon: "error",
          type: "warning",
          title: "Oops...",
          text: errores[0].msg,
        });
        this.botonDesactivado = false;
      } else {
        this.botonDesactivado = false;

        // this.mostrarAlertaNoCorreo();
        this.procesarDatosValidados();
      }
    },
    procesarDatosValidados() {
      this.botonDesactivado = false;

      let template = 0;
      let templateFolio = 0;
      let nombreSender = "";
      let titulo = "";
      let correoSender = "";

      switch (this.tipoSucursal) {
        case "Super Kompras":
          template = 7721122;
          templateFolio = 5200641;
          nombreSender = "Super Kompras";
          titulo = "Código de verificación Super Kompras";
          break;
        case "Acropolis":
          template = 4975552;
          templateFolio = 5200661;
          nombreSender = "Acrópolis";
          titulo = "Código de verificación Acrópolis";
          break;
        case "Surtitienda":
          template = 4975555;
          templateFolio = 5200641;
          nombreSender = "Surtitienda";
          titulo = "Código de verificación Surtitienda";
          break;
      }
      correoSender = "appsk@tiendasgarces.com";

      const objetoDatosUsuario = {
        nombre: this.nombre,
        apellidoPaterno: this.apellidoPaterno,
        apellidoMaterno: this.apellidoMaterno,
        telefono: this.telefono.toString(),
        correo: this.correo,
        codigoPostal: this.codigoPostal.toString(),
        fechaNacimiento: this.formatoFechaNacimiento(),
        sexo: this.sexo,
        correoSender: correoSender,
        nombreSender: nombreSender,
        template: template,
        templateFolio: templateFolio,
        noCorreo: this.correoOpcional ? this.noCorreo : false,
        titulo: titulo,
        sucursal: this.sucursal,
        preregistro: true,
      };
      localStorage.setItem("datosUsuario", JSON.stringify(objetoDatosUsuario));


      this.resetearCampos();

      this.$router.push(this.urlSiguiente);
    },
    cancelarVerificacion() {
      this.resetearCampos();
    },

    resetearCampos() {
      this.nombre = "";
      this.telefono = "";
      this.correo = "";
      this.codigoPostal = "";
      this.fechaNacimiento = "";
      this.sexo = "";
      this.terminos = false;
      this.noCorreo = false;
    },
    revisarMayoriaEdad(fecha) {
      const fechaActual = moment().format("YYYY-MM-DD");
      const fechaActualOffsetTimestamp =
        parseInt(moment(fechaActual).format("x")) + 39600000 + 3540000;
      const fechaRevisar = moment(fecha).format("x");


      // const fechaActual = new Date().getTime();
      // const fechaRevisar = new Date(fecha).getTime();
      // 
      // 

      return fechaActualOffsetTimestamp - fechaRevisar >= 568067623175;
    },
    formatoFechaNacimiento() {

      const arrayFecha = this.fechaNacimiento.split("/");
      const fechaFormatoMoment =
        arrayFecha[2] + "-" + arrayFecha[1] + "-" + arrayFecha[0];
      // 
      // const fechaRecibida = moment(fechaFormatoMoment);
      // 
      // const fechaOffsetDia = parseInt(fechaRecibida.format('x')) - 86400000;
      // 
      // const fechaFormato = moment(fechaOffsetDia).format("YYYY-MM-DD");

      // 
      // const fechaFormato = new Date(this.fechaNacimiento);
      // 
      // const dia = fechaFormato.getDate().toString().padStart(2, "0");
      // 
      // const mes = (fechaFormato.getMonth() + 1).toString().padStart(2, "0");
      // const año = fechaFormato.getFullYear();
      // 
      // return `${año}-${mes}-${dia}`;
      return fechaFormatoMoment;
    },
    cambiarCorreoDefecto() {
      if (!this.noCorreo) {
        this.correo = "appsk@tiendasgarces.com";
      } else {
        this.correo = "";
      }
    },
    mostrarAlertaNoCorreo() {
      this.$swal({
        title: "¿Estás seguro de que no tienes un correo?",
        text: 'En caso de seleccionar la casilla "No tengo un email" perderás el beneficio de tener una recompensa de puntos en tu tarjeta club al verificar tus datos',
        showCancelButton: true,
        cancelButtonText: "Tengo un correo",
        confirmButtonText: "Confirmar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.procesarDatosValidados();
        }
      });
    },
    darAutoFormatoFecha() {
      let fechaFormato = this.fechaNacimiento.replace(/\D/g, ""); // Elimina todos los caracteres no numéricos

      if (fechaFormato.length > 2) {
        fechaFormato =
          fechaFormato.substring(0, 2) + "/" + fechaFormato.substring(2);
      }
      if (fechaFormato.length > 5) {
        fechaFormato =
          fechaFormato.substring(0, 5) + "/" + fechaFormato.substring(5, 9);
      }

      this.fechaNacimiento = fechaFormato;
    },
    llenarListadoSucursales() { },
  },
  watch: {
    configuracionesCorreo(nuevasConfiguraciones) {

      const { preregistro } = nuevasConfiguraciones;
      this.correoOpcional = preregistro;

    },
    tipoSucursal(nuevoTipoSucursal) {
      switch (nuevoTipoSucursal) {
        case "Super Kompras":
          this.listaSucursales = [
            ...this.sucursalesSk,
            ...this.sucursalesSkMicro,
          ];
          break;
        case "Surtitienda":
          this.listaSucursales = [...this.sucursalesSurtitienda];
          break;
        case "Acropolis":
          this.listaSucursales = [...this.sucursalesAcropolis];
          break;
      }
      this.sucursal = "";
    },
    tiendasDisponibles() {
      if (this.tipoSucursal) {
        this.tipoSucursal = this.tipoSucursal;
      }
    },
  },
};
</script>
<template>
  <div class="container">
    <div class="page-title">
      <div class="row">
        <div class="col">
          <h3>Pre registro</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="container d-flex justify-content-center">
    <div class="card w-100 px-1" style="max-width: 900px">
      <form @submit.prevent="validarFormularioVerificacion()">
        <div class="card-body">
          <div class="mb-3">
            <label class="col-form-label pt-0" for="nombre">Nombre</label>
            <input class="form-control" id="nombre" type="text" aria-describedby="nombre"
              placeholder="Introduce tu nombre" v-model.trim="nombre" />
          </div>
          <div class="">
            <div class="row">
              <div class="col-lg col-md-12 mb-3">
                <label class="col-form-label pt-0" for="apellidoPaterno">Apellido paterno</label>
                <input class="form-control" id="apellidoPaterno" type="text" aria-describedby="apellidoPaterno"
                  placeholder="Introduce tu apellido paterno" v-model.trim="apellidoPaterno" />
              </div>
              <div class="col-lg col-md-12 mb-3">
                <label class="col-form-label pt-0" for="apellidoMaterno">Apellido materno</label>
                <input class="form-control" id="apellidoMaterno" type="text" aria-describedby="apellidoMaterno"
                  placeholder="Introduce tu apellido materno" v-model.trim="apellidoMaterno" />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="col-form-label pt-0" for="telefono">Teléfono</label>
            <div class="row">
              <div class="col-lg-1 col-2 d-flex align-items-center justify-content-lg-start justify-content-center"
                style="min-height: 100%">
                <label class="col-form-label" for="prefijo">+52</label>
              </div>
              <div class="col-lg-11 col-10">
                <input class="form-control" id="telefono" type="number" aria-describedby="telefono"
                  placeholder="Introduce tu teléfono" v-model.trim="telefono" />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="col-form-label pt-0" for="correo">Correo electrónico</label>
            <input class="form-control" id="correo" type="text" aria-describedby="correo"
              placeholder="Introduce tu correo electrónico" v-model.trim="correo" :disabled="noCorreo" />
            <div class="checkbox checkbox-dark m-square col-form-label ms-1" v-if="correoOpcional">
              <input id="noCorreo" type="checkbox" @click="cambiarCorreoDefecto()" v-model.trim="noCorreo" />
              <label class="mt-0" for="noCorreo">No tengo correo</label>
            </div>
          </div>
          <div class="">
            <div class="row">
              <div class="col-lg col-md-12 mb-3">
                <label class="col-form-label pt-0" for="codifoPostal">Código postal</label>
                <input class="form-control" id="codifoPostal" type="number" aria-describedby="codigoPostal"
                  placeholder="Introduce tu código postal" v-model.trim="codigoPostal" />
              </div>
              <div class="col-lg col-md-12 mb-3">
                <label class="col-form-label pt-0" for="fechaNacimiento">Fecha de nacimiento</label>
                <!-- <datepicker
                  id="fechaNacimiento"
                  class="datetimepicker-input digits"
                  :enable-time-picker="false"
                  type="date"
                  locale="es"
                  select-text="Confirmar"
                  cancel-text="Cancelar"
                  format="dd/MM/yyyy"
                  v-model.trim="fechaNacimiento"
                /> -->
                <input class="form-control" id="fechaNacimiento" type="tel" aria-describedby="fechaNacimiento"
                  placeholder="DD/MM/AAAA" v-model.trim="fechaNacimiento" @input="darAutoFormatoFecha()" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg col-md-12 mb-3">
              <label class="form-label" for="exampleFormControlSelect30">Tipo de sucursal</label>
              <select class="form-select digits" id="exampleFormControlSelect30" @input="llenarListadoSucursales()"
                v-model="tipoSucursal">
                <option v-for="tipo in listaTipoSucursales">{{ tipo }}</option>
              </select>
            </div>
            <div class="col-lg col-md-12 mb-3">
              <label class="form-label" for="exampleFormControlSelect30">Sucursal</label>
              <select class="form-select digits" id="exampleFormControlSelect30" v-model="sucursal">
                <option v-for="sucursal in listaSucursales" :value="sucursal.division">
                  {{ sucursal.nombre }}
                </option>
              </select>
            </div>
          </div>
          <div class="">
            <div class="row">
              <div class="col-lg col-md-12 mb-3">
                <label class="col-form-label pt-0" for="sexo">Sexo</label>
                <div class="m-t-15 custom-radio-ml">
                  <div class="form-check radio radio-primary">
                    <input class="form-check-input" id="masculino" type="radio" name="masculino" value="Hombre"
                      v-model.trim="sexo" />
                    <label class="form-check-label" for="masculino">Hombre</label>
                  </div>
                  <div class="form-check radio radio-primary">
                    <input class="form-check-input" id="femenino" type="radio" name="femenino" value="Mujer"
                      v-model.trim="sexo" />
                    <label class="form-check-label" for="femenino">Mujer</label>
                  </div>
                  <div class="form-check radio radio-primary">
                    <input class="form-check-input" id="sinEspecificar" type="radio" name="sinEspecificar" value="Otro"
                      v-model.trim="sexo" />
                    <label class="form-check-label" for="sinEspecificar">Sin especificar</label>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-12 d-flex align-items-center mb-3">
                <div class="checkbox checkbox-dark m-square">
                  <div class="d-flex justify-content-start ms-1">
                    <input id="terminos" type="checkbox" v-model.trim="terminos" />
                    <label class="mt-0" for="terminos">Acepto los términos y condiciones</label>
                  </div>
                  <h6 class="f-w-600 ms-1">
                    <a target="_blank" href="https://www.superkompras.com.mx/aviso-privacidad/">Consulta nuestro aviso
                      de
                      privacidad</a>
                    <span> y </span>
                    <a target="_blank"
                      href="https://superkompras.com.mx/terminos-y-condiciones-tarjeta-club-super-kompras-reglas-de-operacion/">Consulta
                      nuestros
                      términos
                      y condiciones</a>
                  </h6>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-end">
          <button class="btn btn-secondary me-2" type="button" @click="cancelarVerificacion()">
            Cancelar
          </button>
          <button class="btn btn-primary" type="submit">Continuar</button>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
.dp__input_wrap input {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
